<template>
<div id="app" >
  <app-header class="animated fadeIn"></app-header>
  <div class="container-fluid">
   <transition name="slide" mode="out-in">
      <router-view>
      </router-view>
    </transition>
  </div>
 <!-- <app-footer></app-footer> -->
</div>
</template>

<script>
import AppHeader from './components/header'

export default {
  name: 'app', 
  methods:{
  },
  components:{  
    AppHeader
  },
  mounted(){

  }
}
</script>

<style lang="scss">
@import '~varmix';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.container-fluid, .col-md-9, .col-md-3, .col-md-10, .col-md-12{
  padding-left:0px !important;
  padding-right:0px !important;
}

.navbar{
  margin-bottom:0px;
}
.row, .col-md-9, .col-md-3, .col-md-10, .col-md-12{
  margin-left:0px!important;
  margin-right:0px!important;
} 

html{
    font-family: 'Open Sans', sans-serif;
}

h1, h3, h2, li, i{
  font-family: 'Fjalla One', sans-serif;
}
</style>



// WEBPACK FOOTER //
// App.vue?4b28474a